import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Box, Button, Stack, Typography } from '@mui/material';
import { equipmentConditions, equipmentYears } from 'modules/equipment';
import { CurrencyInputField, InputField, NumberFormatField, SelectField } from 'components/form';

import { SendApplicationFormValues } from '../../types';

export const EquipmentSection = () => {
  const { control, resetField } = useFormContext<SendApplicationFormValues>();

  return (
    <Stack gap="0.5rem" pt="12px">
      <Typography fontWeight={500}>Equipment Information</Typography>

      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '1rem' }}>
        <InputField
          label="Stock #"
          control={control}
          name="equipment.stockNumber"
          inputProps={{ variant: 'outlined' }}
        />

        <CurrencyInputField
          control={control}
          label="Amount Requested"
          name="equipment.amountRequested"
          textFieldProps={{ variant: 'outlined' }}
        />

        <NumberFormatField
          control={control}
          label="Quantity"
          name="equipment.quantity"
          textFieldProps={{ size: 'small', fullWidth: true, variant: 'outlined' }}
        />

        <SelectField control={control} label="Year" name="equipment.year" options={equipmentYears} variant="outlined" />

        <SelectField
          control={control}
          label="Condition"
          name="equipment.condition"
          options={equipmentConditions}
          variant="outlined"
        />

        <InputField
          label="Serial/VIN#"
          control={control}
          name="equipment.serialVin"
          inputProps={{ variant: 'outlined' }}
        />

        <InputField label="Make" control={control} name="equipment.make" inputProps={{ variant: 'outlined' }} />

        <InputField label="Model" control={control} name="equipment.model" inputProps={{ variant: 'outlined' }} />

        <NumberFormatField
          control={control}
          label="Mileage"
          name="equipment.mileage"
          textFieldProps={{ size: 'small', fullWidth: true, variant: 'outlined' }}
        />

        <InputField
          label="Description"
          control={control}
          name="equipment.description"
          inputProps={{ variant: 'outlined' }}
        />

        <Box />

        <Stack>
          <Button sx={{ alignSelf: 'flex-end' }} color="error" onClick={() => resetField('equipment')}>
            Reset
          </Button>
        </Stack>
      </Box>
    </Stack>
  );
};
